import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetUserIdsBySalaryStructureGraphQlRequest,
  GetUserIdsBySalaryStructureGraphResponse,
} from '../types';

export const getUserIdsBySalaryStructureQuery = gql`
  query PayrollGetUserIdsBySalaryStructure($input: PayrollGetUserIdsBySalaryStructureInput!) {
    payrollGetUserIdsBySalaryStructure(input: $input) {
      data {
        userIds
      }
      code
      success
      message
    }
  }
`;

export const getUserIdsBySalaryStructure = (
  queryVariables: GetUserIdsBySalaryStructureGraphQlRequest,
) => {
  return graphQLApi<
    GetUserIdsBySalaryStructureGraphResponse,
    GetUserIdsBySalaryStructureGraphQlRequest
  >({
    query: getUserIdsBySalaryStructureQuery,
    queryVariables,
  });
};

export default getUserIdsBySalaryStructure;
